export const LOCAL_STORAGE_KEYS = {
  AGE_VERIFICATION_MODAL_SHOWN: "age_verification_modal_shown",
};
